<template>
	<div class="draggable" :style="{ left: x + 'px', top: y + 'px' }" @mousedown="startDrag">
		拖拽我
	</div>
</template>
  
<script>
export default {
	data() {
		return {
			x: 0,
			y: 0,
			isDragging: false,
			offsetX: 0,
			offsetY: 0
		}
	},
	methods: {
		startDrag(event) {
			this.isDragging = true;
			this.offsetX = event.clientX - event.target.getBoundingClientRect().left;
			this.offsetY = event.clientY - event.target.getBoundingClientRect().top;
			document.addEventListener('mousemove', this.drag);
			document.addEventListener('mouseup', this.stopDrag);
		},
		drag(event) {
			if (!this.isDragging) return;
			this.x = event.clientX - this.offsetX;
			this.y = event.clientY - this.offsetY;
		},
		stopDrag() {
			this.isDragging = false;
			document.removeEventListener('mousemove', this.drag);
			document.removeEventListener('mouseup', this.stopDrag);
		}
	}
}
</script>
  
<style scoped>
.draggable {
	width: 100px;
	height: 100px;
	background-color: lightblue;
	position: absolute;
	cursor: grab;
}
</style>
  